<template>
  <div class="conteudoInterno" id="diretor-operacoes">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Análise do nosso diretor de operações</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcBlueBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col40ponto4">
          <img
            title="Fábio Geovane"
            alt="Fábio Geovane"
            src="../assets/imgs/fabio_geovane.jpg"
          />

          <h4 class="h4Destaque">
            “A expressiva marca de
            <span class="non-wrap ubcBlue sanukBlack"
              >R$ 1 bilhão em distribuições</span
            >
            revela um crescimento de 8% em relação ao exercício anterior.”
          </h4>
        </div>
        <div class="col49">
          <p>
            O ano de 2025 representou mais um marco na trajetória de crescimento
            e fortalecimento da UBC. Em um ambiente de constantes transformações
            na indústria da música e no consumo de conteúdo audiovisual,
            reafirmamos nosso compromisso com a excelência na gestão coletiva
            dos direitos autorais, alcançando resultados históricos para nossos
            associados e titulares representados.
          </p>

          <p>
            O principal destaque do ano foi o volume recorde de distribuições
            realizadas. A expressiva marca de
            <span class="ubcBlue sanukBlack"
              >R$ 1 bilhão em distribuições da UBC</span
            >
            revela um crescimento de 8% em relação ao exercício anterior,
            consolidando uma trajetória consistente de expansão e reafirmando a
            confiança dos titulares que escolhem a nossa sociedade para
            administrar seus direitos.
          </p>

          <br />

          <p>
            Os números de 2025 refletem o fortalecimento de diversos segmentos
            da indústria musical, com destaque especial para eventos ao vivo,
            festividades populares e plataformas digitais.
          </p>

          <p>
            Entre os segmentos que apresentaram maior crescimento percentual no
            conjunto da gestão coletiva brasileira, merecem destaque:
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">Carnaval</h4>

          <p>
            O segmento Carnaval cresceu
            <span class="ubcBlue sanukBlack">34,83%</span>, refletindo a força
            contínua da maior manifestação cultural popular do país e sua
            crescente relevância para a geração de direitos autorais.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">Festa Junina</h4>

          <p>
            Outro destaque expressivo foi o segmento Festa Junina, que
            apresentou crescimento de
            <span class="ubcBlue sanukBlack">40,36%</span>. Mostra, mais uma
            vez, a importância econômica e cultural das festividades regionais e
            sua profissionalização em todo o território nacional.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">
            Música ao Vivo e Shows
          </h4>

          <p>
            O mercado de apresentações ao vivo manteve sua trajetória de
            recuperação e expansão.
          </p>
          <p>
            A rubrica
            <span class="ubcBlue sanukBlack">Música ao Vivo</span> teve um
            aumento de <span class="ubcBlue sanukBlack">20,99%</span>; e o
            segmento <span class="ubcBlue sanukBlack">Shows</span>, de
            <span class="ubcBlue sanukBlack">15,81%</span> em relação ao ano
            anterior.
          </p>
          <p>
            Os números refletem o fortalecimento da cadeia de eventos e
            entretenimento ao vivo, impulsionada pela retomada plena das
            atividades presenciais.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">Streaming de Vídeo</h4>

          <p>
            O segmento Streaming de Vídeo manteve-se como um dos principais
            motores de crescimento da arrecadação digital. Em 2025, tivemos um
            crescimento de <span class="ubcBlue sanukBlack">15,97%</span> em
            comparação com o ano de 2024. Uma evidência da consolidação das
            plataformas de VOD (vídeo sob demanda).
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">Streaming de Áudio</h4>

          <p>
            O segmento Streaming de Áudio também apresentou evolução positiva,
            alcançando um crescimento de
            <span class="ubcBlue sanukBlack">6,99%</span> em relação ao
            exercício anterior.
          </p>

          <p>
            A combinação dos segmentos de streaming de áudio e vídeo reforça a
            relevância crescente do ambiente digital para a sustentabilidade
            econômica dos criadores e titulares representados pela UBC.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">
            DIVERSIFICAÇÃO DAS FONTES DE RECEITA
          </h4>

          <p>
            Além dos segmentos em destaque, a UBC observou expansões em
            praticamente todas as rubricas relevantes de distribuição.
          </p>
          <p>
            Os segmentos Rádio, TV Aberta, Casas de Festas e Diversão e
            Sonorização Ambiental mantiveram desempenho positivo, contribuindo
            para a diversificação das receitas e para a estabilidade do modelo
            de distribuição da entidade.
          </p>
          <p>
            Mesmo diante da retração observada na rubrica TV Fechada, -0,90%, o
            desempenho dos demais segmentos foi suficiente para sustentar um
            aumento robusto da distribuição total.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">
            TRANSFORMAÇÃO DIGITAL E MODERNIZAÇÃO DO SITE E DO PORTAL UBC
          </h4>

          <p>
            Em 2025, a UBC também deu um importante passo em sua jornada de
            inovação e transformação digital, com o lançamento de seu novo site
            institucional e portal dos associados.
          </p>
          <p>
            O projeto foi concebido com o objetivo de oferecer uma experiência
            mais moderna, intuitiva e eficiente para os associados.
          </p>
          <p>Entre as principais novidades implementadas, destacam-se:</p>

          <ul class="listItems">
            <li>
              Tradução integral do portal para
              <span class="ubcBlue sanukBlack">três idiomas</span>, ampliando a
              capacidade de atendimento e relacionamento com parceiros
              internacionais;
            </li>
            <li>
              Novo ambiente de navegação com foco em acessibilidade e
              experiência do usuário, onde é possível até selecionar o modo
              visual que o usuário prefere para navegar no site.
            </li>
            <li>Infraestrutura operacional em ambiente de nuvem.</li>
            <li>
              Disponibilização de novos dashboards, rankings e relatórios.
            </li>
          </ul>

          <h4 class="ubcBlue sanukBlack sectionTitle">
            CHIQUINHA: INTELIGÊNCIA ARTIFICIAL A SERVIÇO DOS TITULARES
          </h4>

          <p>
            Como parte desse processo de inovação, a UBC lançou a
            <span class="ubcBlue sanukBlack">Chiquinha</span>, sua nova
            assistente virtual baseada em Inteligência Artificial.
          </p>

          <p>
            A Chiquinha auxilia na orientação sobre serviços, processos, dúvidas
            frequentes e procedimentos operacionais, proporcionando respostas
            mais rápidas e maior autonomia aos usuários.
          </p>

          <p>
            A iniciativa representa mais um passo da UBC na utilização de
            tecnologias inovadoras para aprimorar a experiência de seus
            associados e fortalecer a eficiência operacional da entidade.
          </p>

          <h4 class="ubcBlue sanukBlack sectionTitle">
            MAIS INFORMAÇÃO, MAIS TRANSPARÊNCIA E MAIS CONTROLE PARA O ASSOCIADO
          </h4>

          <p>
            Outra importante evolução do portal foi a disponibilização de novos
            dashboards, relatórios e gráficos interativos.
          </p>
          <p>
            Agora, os associados da UBC contam com ferramentas mais completas
            para acompanhar a evolução de seus recebimentos, analisar tendências
            de distribuição, identificar fontes de receita e compreender de
            forma mais clara a composição dos valores distribuídos mensalmente.
          </p>
          <p>
            Esse investimento reforça o compromisso permanente da UBC com a
            transparência, a governança e a disponibilização de informações
            relevantes para seus titulares.
          </p>
          <p>
            Além do portal, a UBC segue trabalhando e desenvolvendo sistemas
            para cada vez melhor representar seus titulares dentro e fora do
            Brasil, junto a instituições como Cisac, Scapr e IFPI.
          </p>
          <p>
            Seguiremos investindo em inovação, tecnologia, transparência e
            excelência operacional para que os próximos anos sejam marcados por
            ainda mais crescimento e geração de valor para toda a comunidade da
            indústria da música.
          </p>

          <br />
          <p class="ubcBlue sanukBold">Fabio Geovane</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "AnaliseDiretorDeOperacoes",
  props: ["clicked"],

  data() {
    return {
      setaScrollState: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#diretor-operacoes");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.non-wrap {
  white-space: nowrap;
}

.col40ponto4 img {
  width: 100%;
  max-width: 481px;
}

.h4Destaque {
  max-width: 586px;
  margin-top: 110px;
}

@media screen and (max-width: 1345px) {
  .non-wrap {
    white-space: normal;
  }
}

@media screen and (max-width: 800px) {
  .col40ponto4 img {
    margin-bottom: 32px;
  }

  .h4Destaque {
    max-width: unset;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
